/**
 * VideoIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const VideoIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m10.365 16.018 5.503-3.54a.54.54 0 0 0 .255-.479.54.54 0 0 0-.255-.478l-5.503-3.539a.51.51 0 0 0-.585-.028.56.56 0 0 0-.298.513v7.066q0 .342.298.513a.51.51 0 0 0 .585-.028m-6.293 4.185q-.945 0-1.61-.665a2.2 2.2 0 0 1-.665-1.61V6.072q0-.945.665-1.61t1.61-.665h15.856q.945 0 1.61.665t.665 1.61v11.856q0 .944-.665 1.61-.665.665-1.61.665zm0-2.275h15.856V6.072H4.072z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const VideoIcon = makeIcon('VideoIcon', VideoIconSvg)
